const SystemSettingsIndex = () => import('@/views/Dashboard/SystemSettings/SystemSettingsIndex');
const UsersIndex = () => import('@/views/Dashboard/SystemSettings/Users/UsersIndex');
const UsersAll = () => import('@/views/Dashboard/SystemSettings/Users/UsersAll');
const UsersCreate = () => import('@/views/Dashboard/SystemSettings/Users/UsersCreate');
const UsersEdit = () => import('@/views/Dashboard/SystemSettings/Users/UsersEdit');
const UsersShowItem = () => import('@/views/Dashboard/SystemSettings/Users/UsersShowItem');
const SecurityRolesIndex = () => import('@/views/Dashboard/SystemSettings/SecurityRoles/SecurityRolesIndex');
const SecurityRolesAll = () => import('@/views/Dashboard/SystemSettings/SecurityRoles/SecurityRolesAll');
const SecurityRolesDetails = () => import('@/views/Dashboard/SystemSettings/SecurityRoles/SecurityRolesDetails');
const SecurityRolesPermissions = () => import('@/views/Dashboard/SystemSettings/SecurityRoles/SecurityRolesPermissions');
const Products = () => import('@/views/Dashboard/SystemSettings/Products/Products/Products');
const Divisions = () => import('@/views/Dashboard/SystemSettings/Division/Divisions');
const Levels = () => import('@/views/Dashboard/SystemSettings/Levels');
const GatesIndex = () => import('@/views/Dashboard/SystemSettings/Gates/GatesIndex');
const Gates = () => import('@/views/Dashboard/SystemSettings/Gates/Gates');
const GateAccessControlEditor = () => import('@/components/SystemSettings/Gates/GateAccessControlEditor');
const UpdateGateAccessControl = () => import('@/components/SystemSettings/Gates/UpdateGateAccessControl');
const Branches = () => import('@/views/Dashboard/SystemSettings/Branches');
const BranchCreate = () => import('@/views/Dashboard/SystemSettings/Branch/BranchCreate');
const BranchEdit = () => import('@/views/Dashboard/SystemSettings/Branch/BranchEdit');
const BranchShow = () => import('@/views/Dashboard/SystemSettings/Branch/BranchShow');
const Regions = () => import('@/views/Dashboard/SystemSettings/Regions');
const ShiftsSettings = () => import('@/views/Dashboard/SystemSettings/ShiftsSettings');
const MemberFieldsSettings = () => import('@/views/Dashboard/SystemSettings/MemberFieldsSettings');
const ExpenseItems = () => import('@/views/Dashboard/SystemSettings/ExpenseItems');
const CurrencyView = () => import('@/views/Dashboard/SystemSettings/Currency/View/CurrenciesView');
const ClubSettings = () => import('@/views/Dashboard/SystemSettings/ClubSettings');
const CashBoxes = () => import('@/views/Dashboard/SystemSettings/CashBoxes');
const MemberAppSettings = () => import('@/views/Dashboard/SystemSettings/MemberAppSettings');
const BookingPolicySettings = () => import('@/views/Dashboard/SystemSettings/BookingPolicySettings');

export default {
  path: '/system-settings',
  component: SystemSettingsIndex,
  children: [
    {
      path: '/Users/All',
      component: UsersIndex,
      children: [
        {
          path: '/',
          name: 'users',
          component: UsersAll,
          meta: { preserveTableState: true, resetPageStateOnLeave: true },
        },
        {
          path: 'show/:id',
          name: 'users-show',
          component: UsersShowItem,
          meta: { preservePageStateFor: 'users' },
        },
        {
          path: 'create',
          name: 'users-create',
          component: UsersCreate,
          meta: { preservePageStateFor: 'users' },
        },
        {
          path: 'edit/:id',
          name: 'users-edit',
          component: UsersEdit,
          meta: { preservePageStateFor: 'users' },
        },
      ],
    },
    {
      path: 'security-roles-index',
      component: SecurityRolesIndex,
      children: [
        {
          path: '/',
          name: 'security-roles',
          component: SecurityRolesAll,
          meta: { preserveTableState: true },
        },
        {
          path: 'details/:id',
          name: 'security-roles-details',
          component: SecurityRolesDetails,
          meta: { preservePageStateFor: 'security-roles' },
        },
        {
          path: '/permissions/:id',
          name: 'security-roles-permissions',
          component: SecurityRolesPermissions,
        },
      ],
    },
    {
      path: 'products',
      name: 'products',
      component: Products,
      meta: { preserveTableState: true },
    },
    {
      path: 'divisions',
      name: 'divisions',
      component: Divisions,
      meta: { preserveTableState: true },
    },
    {
      path: 'levels',
      name: 'levels',
      component: Levels,
    },
    {
      path: 'gates/index',
      component: GatesIndex,
      children: [
        {
          path: '/',
          name: 'gates',
          component: Gates,
          meta: { preserveTableState: true },
        },
        {
          path: 'gate/accessControl/:id',
          name: 'gate-access-control',
          component: GateAccessControlEditor,
        },
        {
          path: 'gate/accessControl/:id/update',
          name: 'update-gate-access-control',
          component: UpdateGateAccessControl,
        },
      ],
    },
    {
      path: 'branches',
      name: 'branches',
      component: Branches,
    },
    {
      path: 'regions',
      name: 'regions',
      component: Regions,
    },
    {
      path: 'branches/create',
      name: 'branch-create',
      component: BranchCreate,
    },
    {
      path: 'branches/edit/:id',
      name: 'branch-edit',
      component: BranchEdit,
    },
    {
      path: 'branches/show/:id',
      name: 'branch-show',
      component: BranchShow,
    },
    {
      path: 'shifts',
      name: 'shifts',
      component: ShiftsSettings,
    },
    {
      path: 'member-fields',
      name: 'member-fields',
      component: MemberFieldsSettings,
    },
    {
      path: 'expense-items',
      name: 'expense-items',
      component: ExpenseItems,
      meta: { preserveTableState: true },
    },
    {
      path: 'currencies-management',
      name: 'currencies-management',
      component: CurrencyView,
      meta: { preserveTableState: true },
    },
    {
      path: 'club-settings',
      name: 'club-settings',
      component: ClubSettings,
    },
    {
      path: 'cash-boxes',
      name: 'cash-boxes',
      component: CashBoxes,
    },
    {
      path: 'member-app-settings',
      name: 'member-app-settings',
      component: MemberAppSettings,
    },
    {
      path: 'booking-policy',
      name: 'booking-policy',
      component: BookingPolicySettings,
    },
  ],
};
